import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosClient from "../../../axios-client";
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css"; // Ensure CSS is imported

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const globalDiv = document.getElementById("globalDiv");
    if (globalDiv) {
      globalDiv.style.backgroundColor = "#ecf2ff";
      globalDiv.style.padding = "0px";

      return () => {
        globalDiv.style.backgroundColor = ""; // Clean up
        globalDiv.style.padding = ""; // Clean up
      };
    }
  }, []);

  useEffect(() => {
    const fullWidthNew = document.getElementById("fullWidthNew");
    if (fullWidthNew) {
      fullWidthNew.style.width = "100%";

      return () => {
        fullWidthNew.style.width = "";
      };
    }
  }, []);

  const handleVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [formData, setFormData] = useState({
    username: "Admin", // Default username as per your requirement
    email: "",
    password: "",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axiosClient.post("/admin/login", formData);
      console.log("login res", response.data);

      if (response.data.success) {
        // Clear error if login succeeds
        setError("");
        iziToast.success({
          message: "Login successful",
          position: "topCenter",
        });

        // Store relevant information and navigate based on role
        const result = response.data;
        localStorage.setItem("Admin_Token", result.token);

        if (result.success === true) {
          localStorage.setItem("Admin_id", result.id);
          navigate("/admin/dashboard");
        }
      } else {
        setError("Login failed. Please try again.");
        iziToast.error({
          message: "Login failed",
          position: "topCenter",
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        console.log("API Error:", error.response.data.message);
        setError(error.response.data.message);
        iziToast.error({
          message: error.response.data.message,
          position: "topCenter",
        });
      } else {
        setError("An unexpected error occurred. Please try again.");
        iziToast.error({
          message: "An unexpected error occurred. Please try again.",
          position: "topCenter",
        });
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <div className="bg-login-blue shadow-custom-login rounded-2xl flex flex-wrap w-full">
      <div className="w-full lg:w-[50%]">
        <img
          src="/images/Mobilelogin.png"
          alt="Login Illustration"
          className="w-full"
        />
      </div>
      <div className="w-full lg:w-[50%] flex flex-col justify-center items-center shadow-lg bg-white">
        <div className="flex items-center">
          <h1 className="font-montserrat font-semibold text-[36px] text-m-blue ml-3">
            Welcome Admin
          </h1>
        </div>
        <p className="font-poppins font-medium text-lg text-dark-gray">
          Please Login to your Admin account
        </p>
        <form className="w-full" onSubmit={handleSubmit}>
          <div className="w-full lg:w-8/12 mx-auto mt-3">
            <label className="block font-poppins font-medium text-base mb-1">
              Email Id
            </label>
            <input
              type="email"
              className="w-full p-2 bg-login-input-blue rounded-[10px] border focus:outline-none font-normal font-poppins text-sm text-gray-3"
              value={formData.email}
              placeholder="Enter your email"
              name="email"
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full lg:w-8/12 mx-auto my-3">
            <label className="block font-poppins font-medium text-base mb-1">
              Password
            </label>
            <div className="flex w-full relative border bg-login-input-blue rounded-[10px]">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full p-2 bg-login-input-blue rounded-[10px] focus:outline-none font-normal font-poppins text-sm text-gray-3"
                placeholder="Enter your password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span className="absolute right-[10px] top-[6px]">
                <i
                  className={`cursor-pointer ${
                    showPassword ? "bi bi-eye-slash" : "bi bi-eye"
                  }`}
                  onClick={handleVisibility}
                ></i>
              </span>
            </div>
          </div>
          <div className="w-full lg:w-8/12 mx-auto pt-3">
            <button
              type="submit"
              className="w-full py-[10px] rounded-[10px] text-center font-poppins text-lg font-medium bg-[#2e3192] text-white hover:opacity-90 transition-opacity"
            >
              Login
            </button>
          </div>
          <div className="w-full lg:w-8/12 mx-auto text-center mt-4">
            <p className="font-poppins text-sm text-dark-gray">
              Don't have an Admin account?{" "}
              <Link
                to="/admin/register"
                className="text-[#2e3192] font-semibold underline ml-1"
              >
                Register here
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
